module.exports = __webpack_public_path__ + "img/aqfh-img-31.1253f778.png";